import type { ObjectMetadata } from '@olytic/foundation';

import { formatDate, formatNumber } from '../../objects/format';
import { OBJECT_DEFS } from '../../objects/objectDefs';
import { asDate, asDateTime, asCheck, createdByField, field, lastModifiedByField, lookup, type Row, show } from './kit';

const def = OBJECT_DEFS['time-entries'];

/** A time entry: hours one person logged against a project on a day. Rationale: time-entries.md. */
export const timeEntries: ObjectMetadata<Row> = {
  key: def.key,
  singular: 'Time entry',
  plural: def.label,
  icon: def.icon,
  listColumns: def.columns,
  details: [
    field('entry_date', 'Date', { format: asDate }),
    field('hours', 'Hours', { format: show((v) => formatNumber(v)) }),
    field('project_name', 'Project', { link: lookup('projects', 'project_id') }),
    field('account_name', 'Account', { link: lookup('accounts', 'account_id') }),
    field('billable', 'Billable', { format: asCheck }),
    field('owner_name', 'Person'),
    field('notes', 'Notes', { wide: true }),
    field('created_at', 'Created', { format: asDateTime }),
    field('updated_at', 'Last Modified', { format: asDateTime }),
    createdByField(),
    lastModifiedByField(),
  ],
  sections: [
    { key: 'identity', fields: ['entry_date', 'hours', 'project_name', 'account_name', 'billable', 'owner_name'] },
    { key: 'notes', label: 'Notes', fields: ['notes'] },
    { key: 'system', label: 'System', collapsed: true, fields: ['created_at', 'created_by_name', 'updated_at', 'last_modified_by_name'] },
  ],
  related: [],
  titleOf: (row) => [formatDate(row.entry_date), row.project_name].filter((part) => part !== '' && part !== null && part !== undefined).join(' · ') || 'Time entry',
  searchKeys: ['notes', 'project_name', 'account_name'],
};
